import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const menuAPI = {
  getAll: () => axios.get(`${API}/menu`),
  getPromoted: () => axios.get(`${API}/menu/promoted`),
  getOne: (id) => axios.get(`${API}/menu/${id}`),
  create: (data) => axios.post(`${API}/menu`, data),
  update: (id, data) => axios.put(`${API}/menu/${id}`, data),
  delete: (id) => axios.delete(`${API}/menu/${id}`),
};

export const orderAPI = {
  getAll: (status = null) => axios.get(`${API}/orders`, { params: { status } }),
  getOne: (id) => axios.get(`${API}/orders/${id}`),
  create: (data) => axios.post(`${API}/orders`, data),
  updateStatus: (id, status) => axios.put(`${API}/orders/${id}/status`, { status }),
  updateKitchenStatus: (id, kitchen_status) => axios.put(`${API}/orders/${id}/kitchen-status`, { kitchen_status }),
  updateBeverageStatus: (id, beverage_status) => axios.put(`${API}/orders/${id}/beverage-status`, { beverage_status }),
  transfer: (id) => axios.post(`${API}/orders/${id}/transfer`),
  track: (orderNumber) => axios.get(`${API}/orders/track/${orderNumber}`),
};

export const dashboardAPI = {
  getStats: () => axios.get(`${API}/dashboard/stats`),
};

export const categoriesAPI = {
  getAll: () => axios.get(`${API}/categories`),
};

export const tablesAPI = {
  getAll: () => axios.get(`${API}/tables`),
  getOne: (id) => axios.get(`${API}/tables/${id}`),
  create: (data) => axios.post(`${API}/tables`, data),
  update: (id, data) => axios.put(`${API}/tables/${id}`, data),
  delete: (id) => axios.delete(`${API}/tables/${id}`),
  getQR: (id, baseUrl) => axios.get(`${API}/tables/${id}/qr`, { params: { base_url: baseUrl } }),
  getBatchQR: (baseUrl) => axios.post(`${API}/tables/qr/batch`, null, { params: { base_url: baseUrl } }),
};

export const settingsAPI = {
  get: () => axios.get(`${API}/settings`),
  update: (data) => axios.put(`${API}/settings`, data),
};

export const blogAPI = {
  getAll: (publishedOnly = true) => axios.get(`${API}/blog`, { params: { published_only: publishedOnly } }),
  getOne: (id) => axios.get(`${API}/blog/${id}`),
  create: (data) => axios.post(`${API}/blog`, data),
  update: (id, data) => axios.put(`${API}/blog/${id}`, data),
  delete: (id) => axios.delete(`${API}/blog/${id}`),
  uploadImage: (id, formData) => axios.post(`${API}/blog/${id}/upload-image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
};

export const analyticsAPI = {
  getRevenue: (period, startDate = null, endDate = null) => 
    axios.get(`${API}/analytics/revenue`, { 
      params: { period, start_date: startDate, end_date: endDate }
    }),
  getTopDishes: (period, startDate = null, endDate = null, limit = 10) =>
    axios.get(`${API}/analytics/top-dishes`, {
      params: { period, start_date: startDate, end_date: endDate, limit }
    }),
  resetOrderNumbers: () => axios.post(`${API}/analytics/reset-order-numbers`),
  clearTestOrders: () => axios.post(`${API}/analytics/clear-test-orders`),
};

export const staffAPI = {
  login: (data) => axios.post(`${API}/staff/login`, data),
  me: (token) => axios.get(`${API}/staff/me`, { headers: { Authorization: `Bearer ${token}` } }),
  list: () => axios.get(`${API}/staff/list`),
  create: (data) => axios.post(`${API}/staff/create`, data),
  delete: (id) => axios.delete(`${API}/staff/${id}`),
  toggle: (id) => axios.put(`${API}/staff/${id}/toggle`),
  resetPassword: (id, password) => axios.put(`${API}/staff/${id}/password`, { password }),
};

export const serviceAdminAPI = {
  login: (data) => axios.post(`${API}/service-admin/login`, data),
  me: (token) => axios.get(`${API}/service-admin/me`, { headers: { Authorization: `Bearer ${token}` } }),
  list: () => axios.get(`${API}/service-admin/list`),
  create: (data) => axios.post(`${API}/service-admin/create`, data),
  delete: (id) => axios.delete(`${API}/service-admin/${id}`),
  toggle: (id) => axios.put(`${API}/service-admin/${id}/toggle`),
  resetPassword: (id, password) => axios.put(`${API}/service-admin/${id}/password`, { password }),
};

export const bannersAPI = {
  getAll: (position = null, activeOnly = false) => axios.get(`${API}/banners`, { params: { position, active_only: activeOnly } }),
  create: (data) => axios.post(`${API}/banners`, data),
  update: (id, data) => axios.put(`${API}/banners/${id}`, data),
  delete: (id) => axios.delete(`${API}/banners/${id}`),
  uploadImage: (id, formData) => axios.post(`${API}/banners/${id}/upload-image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const attractionsAPI = {
  getAll: (activeOnly = false) => axios.get(`${API}/attractions`, { params: { active_only: activeOnly } }),
  create: (data) => axios.post(`${API}/attractions`, data),
  update: (id, data) => axios.put(`${API}/attractions/${id}`, data),
  delete: (id) => axios.delete(`${API}/attractions/${id}`),
  uploadImage: (id, formData) => axios.post(`${API}/attractions/${id}/upload-image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const bookingsAPI = {
  getAll: (status = null) => axios.get(`${API}/bookings`, { params: { status } }),
  create: (data) => axios.post(`${API}/bookings`, data),
  updateStatus: (id, status) => axios.put(`${API}/bookings/${id}/status`, { status }),
  delete: (id) => axios.delete(`${API}/bookings/${id}`),
};

export const rentalsAPI = {
  getPartners: (location = null, activeOnly = false) => axios.get(`${API}/rentals/partners`, { params: { location, active_only: activeOnly } }),
  createPartner: (data) => axios.post(`${API}/rentals/partners`, data),
  updatePartner: (id, data) => axios.put(`${API}/rentals/partners/${id}`, data),
  deletePartner: (id) => axios.delete(`${API}/rentals/partners/${id}`),
  uploadImage: (id, formData) => axios.post(`${API}/rentals/partners/${id}/upload-image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  approvePartner: (id, data) => axios.post(`${API}/rentals/partners/${id}/approve`, data),
  getBookings: (status = null) => axios.get(`${API}/rentals/bookings`, { params: { status } }),
  createBooking: (data) => axios.post(`${API}/rentals/bookings`, data),
  updateBookingStatus: (id, status) => axios.put(`${API}/rentals/bookings/${id}/status`, { status }),
  getZaloLink: (bookingId) => axios.get(`${API}/rentals/bookings/${bookingId}/zalo-link`),
  // Partner auth
  register: (data) => axios.post(`${API}/rentals/register`, data),
  uploadTempImage: (formData) => axios.post(`${API}/rentals/upload-temp-image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  partnerLogin: (data) => axios.post(`${API}/rentals/partner-login`, data),
  partnerMe: (token) => axios.get(`${API}/rentals/partner/me`, { headers: { Authorization: `Bearer ${token}` } }),
  partnerUpdate: (token, data) => axios.put(`${API}/rentals/partner/me`, data, { headers: { Authorization: `Bearer ${token}` } }),
  partnerBookings: (token) => axios.get(`${API}/rentals/partner/bookings`, { headers: { Authorization: `Bearer ${token}` } }),
  partnerCommission: (token) => axios.get(`${API}/rentals/partner/commission`, { headers: { Authorization: `Bearer ${token}` } }),
};

export const allBookingsAPI = {
  getAll: () => axios.get(`${API}/all-bookings`),
};
